module.exports = __webpack_public_path__ + "static/01-2385d6806d5798d15542434d7fa46d61.png";